import { render, staticRenderFns } from "./ExchangeAccount.vue?vue&type=template&id=64eb7337&scoped=true"
import script from "./ExchangeAccount.vue?vue&type=script&lang=ts"
export * from "./ExchangeAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb7337",
  null
  
)

export default component.exports